<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="2">
                <el-button :loading="exporting" icon="el-icon-download" @click="download">{{$t('common.export')}}</el-button>
            </el-col>
            <el-col :span="6">
                <el-input v-model="filter.claimNumber" :placeholder="$t('common.claimNumber')"></el-input>
            </el-col>
            <el-col :span="6">
                <el-input v-model="filter.part" :placeholder="$t('common.partNumber')"></el-input>
            </el-col>
            <el-col :span="4">
                <el-date-picker v-model="filter.dateFrom" type="date" :placeholder="$t('common.dateFrom')"></el-date-picker>
            </el-col>
            <el-col :span="6">
                <el-date-picker v-model="filter.dateTo" type="date" :placeholder="$t('common.dateTo')"></el-date-picker>
            </el-col>
        </el-row>

        <el-table size="mini" :data="parts" v-loading="loading" class="tablewithshading">
            <el-table-column prop="claimNumber" :label="$t('common.claimNumber')"></el-table-column>
            <el-table-column :label="$t('reports.claimDate')">
                <template slot-scope="scope">
                    {{scope.row.raisedOn | date }}
                </template>
            </el-table-column>
            <el-table-column prop="no" :label="$t('common.number')" width="100"></el-table-column>
            <el-table-column prop="description" :label="$t('common.description')"></el-table-column>
            <el-table-column prop="quantity" :label="$t('common.quantity')" width="100"></el-table-column>
            <el-table-column :label="$t('common.listPrice')" width="100">
                <template slot-scope="scope">
                    {{scope.row.price | money}}
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.extendedPrice')" width="120">
                <template slot-scope="scope">
                    {{scope.row.extendedPrice | money}}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="total">
        </el-pagination>
    </div>
</template>

<script>
import api from "../api";

export default {
  name: "used-parts-list-report",
  data() {
    return {
      loading: false,
      parts: [],
      filter: {
        part: undefined,
        claimNumber: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        serviceCompany: window.currentCompany.id
      },
      currentPage: 1,
      total: 0,
      exporting: false
    };
  },
  created() {
    this.loadParts();
  },
  watch: {
    filter: {
      deep: true,
      handler: function(val) {
        this.currentPage = 1;
        this.loadParts();
      }
    }
  },
  methods: {
    loadParts() {
      this.loading = true;
      api.getUsedParts(this.currentPage, this.filter).then(response => {
        this.loading = false;
        this.parts = response.data.items;
        this.total = response.data.total;
      });
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadParts();
    },
    download() {
      this.exporting = true;
      api
        .downloadUsedParts(this.filter)
        .then(() => {
          this.exporting = false;
        })
        .catch(() => {
          this.exporting = false;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// ClientApp/app/reports/components/UsedPartsList.vue